import { FramePosition } from '../aggregates/fm/frame/frame-position.constants';
import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_frame_file_default_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    frame_guid: fromDatatype.GuidDataFieldInterface;
    item_guid: fromDatatype.GuidDataFieldInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    frame_start_position: FramePosition;
    frame_end_position: FramePosition;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_frame_file_default_link_RowClass implements bl_fi_frame_file_default_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    frame_guid: fromDatatype.GuidDataFieldInterface;
    item_guid: fromDatatype.GuidDataFieldInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    frame_start_position: FramePosition;
    frame_end_position: FramePosition;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}